// src/pages/Gallery.jsx
import React from "react";

export default function Gallery() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white mb-6">
        Gallery
      </h1>
      <p className="text-neutral-400 mb-10 max-w-2xl">
        Clean installs, aggressive fitments and daily-driven cars that still look fresh.
        Wraps/PPF gallery will live here. For now, check our socials for the latest work.
      </p>

      <div className="border border-dashed border-neutral-700 rounded-2xl p-10 text-center text-neutral-500">
        Wraps gallery coming soon. Drop your car details on the quote page and maybe it ends
        up here.
      </div>
    </section>
  );
}
